import { faker as faker_1 } from "@faker-js/faker";
import { class_type } from "./fable_modules/fable-library.3.7.1/Reflection.js";

const faker = faker_1;

export class Name {
    constructor() {
    }
}

export function Name$reflection() {
    return class_type("Faker.Name", void 0, Name);
}

export function Name_FirstName() {
    return faker.name.firstName();
}

export function Name_LastName() {
    return faker.name.lastName();
}

export class DataType {
    constructor() {
    }
}

export function DataType$reflection() {
    return class_type("Faker.DataType", void 0, DataType);
}

export function DataType_Number_Z524259A4(max) {
    return faker.datatype.number(max);
}

export function DataType_DateTime_7F9DDECF(max) {
    return faker.datatype.datetime({
        max: max,
    });
}

export class Helpers {
    constructor() {
    }
}

export function Helpers$reflection() {
    return class_type("Faker.Helpers", void 0, Helpers);
}

export function Helpers_Shuffle_404FCA0C(seq) {
    return faker.helpers.shuffle(seq);
}

//# sourceMappingURL=Faker.fs.js.map
